import { LocalStorageUtil } from '@modernloop/shared/utils';

const MLoopBackendUrlNamespace = `mLoopBackendUrl`;
const MLoopDisableBatchGraphqlQueriesNamespace = `mLoopDisableBatchGraphqlQueries`;
const MLoopShowAgentDebugLogsNamespace = `mLoopShowAgentDebugLogs`;

class DevOverrides {
  /**
   * LOCAL BACKEND URL
   */
  static getLocalBackendUrl() {
    return LocalStorageUtil.get(MLoopBackendUrlNamespace) as string | null;
  }

  static setLocalBackendUrl(value: string) {
    LocalStorageUtil.set(MLoopBackendUrlNamespace, value);
  }

  static removeLocalBackendUrl() {
    LocalStorageUtil.remove(MLoopBackendUrlNamespace);
  }

  /**
   * DISABLE BATCH GRAPHQL QUERIES
   */
  static getIsBatchDisabled() {
    return Boolean(LocalStorageUtil.get(MLoopDisableBatchGraphqlQueriesNamespace));
  }

  static setIsBatchDisabled(value: boolean) {
    LocalStorageUtil.set(MLoopDisableBatchGraphqlQueriesNamespace, value);
  }

  static removeIsBatchDisabled() {
    LocalStorageUtil.remove(MLoopDisableBatchGraphqlQueriesNamespace);
  }

  /**
   * SHOW AGENT DEBUG LOGS
   */
  static getShowAgentDebugLogs() {
    return Boolean(LocalStorageUtil.get(MLoopShowAgentDebugLogsNamespace));
  }

  static setShowAgentDebugLogs(value: boolean) {
    LocalStorageUtil.set(MLoopShowAgentDebugLogsNamespace, value);
  }
}

export default DevOverrides;
